.componentDetails {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.componentType {
  text-transform: uppercase;
  font-weight: var(--font-weight-black);
}

.componentType,
.componentHeader {
  margin-right: var(--space-xs);
}

.updated {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .initials {
    margin-left: var(--space-s);
  }
}

.row {
  cursor: pointer;
}
